/* eslint-disable @typescript-eslint/no-explicit-any */
import { MonthCaption } from "../components/MonthCaption.js";
import { Week } from "../components/Week.js";
import { useDayPicker } from "../useDayPicker.js";
/**
 * @deprecated This component has been renamed. Use `MonthCaption` instead.
 * @protected
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export const Caption = MonthCaption;
/**
 * @deprecated This component has been renamed. Use `Week` instead.
 * @protected
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export const Row = Week;
/**
 * @deprecated This type has been removed to `useDayPicker`.
 * @protected
 * @group Hooks
 */
export const useNavigation = useDayPicker;
//# sourceMappingURL=deprecated.js.map